import { render, staticRenderFns } from "./newspaper-index.vue?vue&type=template&id=8861eee2&"
import script from "./newspaper-index.vue?vue&type=script&lang=js&"
export * from "./newspaper-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports